import './style/drone-Q10.scss'

$('.product-video-box .watch-video').click(function () {
  $('.product-video-box .video-mask').show()
  $('.product-video-box .video-mask video').attr('src','https://static.qifeizn.com/resources/os/videos/new-Q10.mp4');
})
$('.product-video-box .video-close').click(function () {
  $('.product-video-box .video-mask').hide()
  $('.product-video-box .video-mask video').attr('src','');
})
$('.tab-title li').click(function(){
  $(this).addClass('show')
  $(this).addClass('active')
  $(this).siblings().removeClass('show')
  $(this).siblings().removeClass('active')
  $('.tab-content div').eq($(this).index()).addClass('show')
  $('.tab-content div').eq($(this).index()).siblings().removeClass('show')
})